<template>
    <people :people="coaches" @updateChosen="chosen => chosenCoach = chosen">
        <template slot="chosen-card">
            <chosen-person v-if="chosenCoach.firstName"
                           :connected-people="coachAthleteMapping[chosenCoach.id]"
                           connected-people-headline="Sportler"
                           :first-name="chosenCoach.firstName"
                           :last-name="chosenCoach.lastName"
                           :img="$helper.imgServerUrl() + chosenCoach.img"
                           :phone="chosenCoach.phone"
                           :email="chosenCoach.email"
                           :info-text="coachInfoTextById[chosenCoach.id] ? coachInfoTextById[chosenCoach.id].info : ''">
            </chosen-person>
        </template>
    </people>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import People from "../content/club/people/People";
    import ChosenPerson from "../content/club/people/ChosenPerson";
    import {Resize, Scroll} from 'vuetify/es5/directives'

    export default {
        name: "CoachPage",
        components: {ChosenPerson, People},
        computed: {
            ...mapGetters(['coaches', 'coachInfoTextById', 'coachAthleteMapping'])
        },
        directives: {
            Resize, Scroll
        },
        data() {
            return {
                chosenCoach: {}
            }
        },
        methods: {
            ...mapActions(['getAllUsers', 'getCoachInfoText', 'getCoachAthleteMapping'])
        },
        mounted() {
            if (this.coaches.length === 0) {
                this.getAllUsers()
            }
            if (!(this.coachInfoTextById && this.coachInfoTextById.length > 0)) {
                this.getCoachAthleteMapping()
                this.getCoachInfoText()
            }
            setTimeout(() => {
                this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})
            }, 100)
        }
    }
</script>

